import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Stethoscope, ShieldCheck, Info, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const MobileNavbar = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // 1. Delta check: only toggle if user scrolls more than 10px
      if (Math.abs(currentScrollY - lastScrollY) < 10) return;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling Down - Hide Dock
        setIsVisible(false);
      } else {
        // Scrolling Up - Show Dock
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const navItems = [
    { name: 'Home', path: '/', icon: <Home size={20} /> },
    { name: 'Services', path: '/services', icon: <Stethoscope size={20} /> },
    { name: 'Why Us', path: '/why-optirev', icon: <ShieldCheck size={20} /> },
    { name: 'About', path: '/about', icon: <Info size={20} /> },
    { name: 'Contact', path: '/contact', icon: <Phone size={20} /> },
  ];

  return (
    <AnimatePresence>
      <motion.nav
        // 2. We animate 'y' (vertical) while keeping centering classes solid
        initial={{ y: 0, opacity: 1 }}
        animate={{ 
          y: isVisible ? 0 : 120, // Move it further down to hide completely
          opacity: isVisible ? 1 : 0 
        }}
        transition={{ 
          type: "spring", 
          stiffness: 260, 
          damping: 30 
        }}
        // 3. FIXED CENTERING: left-0 right-0 mx-auto is more stable than -translate-x-1/2
        className="md:hidden fixed bottom-8 left-0 right-0 mx-auto z-[999] w-[92%] max-w-md pointer-events-none"
      >
        {/* Inner container needs pointer-events-auto to be clickable */}
        <div className="bg-white/80 backdrop-blur-2xl border border-white/40 shadow-[0_20px_50px_rgba(0,0,0,0.15)] rounded-[2.5rem] px-6 py-4 flex justify-between items-center pointer-events-auto">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link 
                key={item.name} 
                to={item.path} 
                className="flex flex-col items-center gap-1.5 relative"
              >
                <div className={`p-2.5 rounded-2xl transition-all duration-300 ${
                  isActive 
                  ? 'bg-[#1e3a8a] text-white scale-110 shadow-lg shadow-[#1e3a8a]/20' 
                  : 'text-slate-400 hover:bg-slate-100'
                }`}>
                  {item.icon}
                </div>
                
                {isActive && (
                  <motion.div 
                    layoutId="activeDot"
                    className="absolute -bottom-1 w-1 h-1 bg-[#14b8a6] rounded-full"
                  />
                )}
                
                <span className={`text-[9px] font-black uppercase tracking-widest ${
                  isActive ? 'text-[#1e3a8a]' : 'text-slate-400'
                }`}>
                  {item.name}
                </span>
              </Link>
            );
          })}
        </div>
      </motion.nav>
    </AnimatePresence>
  );
};

export default MobileNavbar;